import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.2579 11H3.74967C3.60085 10.9978 3.45591 10.9503 3.33283 10.8634C3.20975 10.7765 3.11394 10.6539 3.05727 10.5109C3.0006 10.368 2.98557 10.2108 3.01404 10.0591C3.04251 9.90731 3.11323 9.76756 3.21742 9.65715L7.46015 5.23365C7.53084 5.15962 7.61493 5.10085 7.70759 5.06075C7.80024 5.02065 7.89963 5 8 5C8.10037 5 8.19976 5.02065 8.29241 5.06075C8.38507 5.10085 8.46916 5.15962 8.53985 5.23365L12.7826 9.65715C12.8868 9.76756 12.9575 9.90731 12.986 10.0591C13.0144 10.2108 12.9994 10.368 12.9427 10.5109C12.8861 10.6539 12.7902 10.7765 12.6672 10.8634C12.5441 10.9503 12.3992 10.9978 12.2503 11H12.2579Z",
		fill: "currentColor"
	})
});
export default SvgSortUp;
